module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/5-4f23e6942c5768abd8d2a7a0dbbdd72c.jpg";